import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CommonStyles.css';

/**
 * Modal for boosting listing visibility
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Function to close the modal
 * @param {Object} props.listing - The listing to boost
 */
const BoostModal = ({ isOpen, onClose, listing }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleBoost = (type, price) => {
    // Navigate to payment page with boost info
    navigate('/payment', {
      state: {
        paymentType: 'listingBoost',
        amount: price,
        title: `${type} Boost for "${listing.title}"`,
        itemId: listing.id,
        boostType: type,
        returnPath: '/profile/user123' // Hardcoded for demo
      }
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content boost-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Boost Your Listing</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <p className="boost-intro">
          Get more visibility for your listing and increase your chances of a quick sale!
        </p>
        
        <div className="boost-options">
          <div className="boost-option">
            <div className="boost-option-header">
              <h3>Standard Boost</h3>
              <span className="boost-price">HK$20</span>
            </div>
            <div className="boost-details">
              <p className="boost-duration">3 Days</p>
              <ul className="boost-features">
                <li>Highlighted placement in search results</li>
                <li>Priority in category pages</li>
                <li>Higher visibility to relevant buyers</li>
              </ul>
              <button 
                className="boost-button standard-boost"
                onClick={() => handleBoost('Standard', 20)}
              >
                Select Standard
              </button>
            </div>
          </div>
          
          <div className="boost-option premium">
            <div className="boost-badge">Best Value</div>
            <div className="boost-option-header">
              <h3>Premium Boost</h3>
              <span className="boost-price">HK$50</span>
            </div>
            <div className="boost-details">
              <p className="boost-duration">7 Days</p>
              <ul className="boost-features">
                <li>Priority in category pages</li>
                <li>Inclusion in 'Featured Items' section</li>
                <li>Maximum visibility to potential buyers</li>
              </ul>
              <button 
                className="boost-button premium-boost"
                onClick={() => handleBoost('Premium', 50)}
              >
                Select Premium
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoostModal; 